module.exports = __webpack_public_path__ + "img/dot-interro.22d3d8fd.svg";